import { render, staticRenderFns } from "./buscarClientes2.vue?vue&type=template&id=120acb13&scoped=true&"
import script from "./buscarClientes2.vue?vue&type=script&lang=js&"
export * from "./buscarClientes2.vue?vue&type=script&lang=js&"
import style0 from "./buscarClientes2.vue?vue&type=style&index=0&id=120acb13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120acb13",
  null
  
)

export default component.exports